import PropTypes from "prop-types";
import React from "react";
import validator from "validator";
import { FORM_FIELDS, FORM_VALIDATION } from "../../constants";
import { FormTextInput } from "../core";

export const SearchFormExternal = ({ register, errors = {} }) => {
  return (
    <>
      <FormTextInput
        labelName={FORM_FIELDS.SERVICE_PROVIDER_NAME}
        id="serviceProviderName"
        required={true}
        {...register("serviceProviderName", {
          required: FORM_VALIDATION.SERVICE_PROVIDER_NAME,
        })}
        error={errors.serviceProviderName}
      />
      <FormTextInput
        labelName={FORM_FIELDS.PRIMARY_CONTACT_EMAIL}
        id="primaryEmail"
        requiredAny={true}
        {...register("primaryEmail", {
          validate: (value) => {
            if (value && !validator.isEmail(value)) {
              return FORM_VALIDATION.INVALID_CONTACT_EMAIL;
            }
            return true;
          },
        })}
        error={errors.primaryEmail}
      />
      <FormTextInput
        labelName={FORM_FIELDS.REQUEST_ID}
        id="requestId"
        required={true}
        {...register("requestId", {
          required: FORM_VALIDATION.REQUEST_ID,
        })}
        error={errors.requestId}
      />
      <FormTextInput
        labelName={FORM_FIELDS.SECONDARY_CONTACT_EMAIL}
        id="secondaryEmail"
        requiredAny={true}
        {...register("secondaryEmail", {
          validate: (value) => {
            if (value && !validator.isEmail(value)) {
              return FORM_VALIDATION.INVALID_CONTACT_EMAIL;
            }
            return true;
          },
        })}
        error={errors.secondaryEmail}
      />
    </>
  );
};

SearchFormExternal.propTypes = {
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
};
